export const editorKey = process.env.REACT_APP_EDITOR_API_KEY;

export const EditorPlugin = [
  'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
  'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
  'insertdatetime', 'media', 'table', 'help', 'wordcount', 'nonbreaking'
];

export const EditorToolBar =
  'undo redo | bold italic underline backcolor | alignleft aligncenter alignright alignjustify bullist | removeformat nonbreaking';